import { Errors } from '../objects/errors';

export const SET_ERRORS = 'RESET_PASSWORD_SET_ERRORS';
export const UPDATE_CONFIRM_NEW_PASSWORD = 'RESET_PASSWORD_UPDATE_CONFIRM_NEW_PASSWORD';
export const UPDATE_NEW_PASSWORD = 'RESET_PASSWORD_UPDATE_NEW_PASSWORD';

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Errors
}

interface UpdateConfirmNewPasswordAction {
    type: typeof UPDATE_CONFIRM_NEW_PASSWORD,
    payload: string
}

interface UpdateNewPasswordAction {
    type: typeof UPDATE_NEW_PASSWORD,
    payload: string
}

export type ResetPasswordActionTypes = SetErrorsAction | UpdateConfirmNewPasswordAction | UpdateNewPasswordAction;